import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/JwtService";
/**
 * @description service to call HTTP request via Axios
 */
class ApiService {
    /**
     * @description initialize vue axios
     */
    static init(app) {
        ApiService.vueInstance = app;
        if (!ApiService.vueInstance.axios)
            ApiService.vueInstance.use(VueAxios, axios);
        //ApiService.vueInstance.axios.defaults.baseURL = import.meta.env.VITE_API_URL;
        ApiService.BaseUrl = import.meta.env.VITE_API_URL;
    }
    /**
     * @description set the default HTTP request headers
     */
    static setHeader() {
        ApiService.vueInstance.axios.defaults.headers.common["Authorization"] = `Bearer ${JwtService.getToken()}`;
        ApiService.vueInstance.axios.defaults.headers.common["Accept"] =
            "application/json";
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static query(resource, params) {
        return ApiService.vueInstance.axios.get(resource, params);
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static get(resource, slug = "") {
        return ApiService.vueInstance.axios.get(`${ApiService.BaseUrl}/${resource}/${slug}`);
    }
    /**
     * @description set the POST HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static post(resource, params) {
        return ApiService.vueInstance.axios.post(`${ApiService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description send the UPDATE HTTP request
     * @param resource: string
     * @param slug: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static update(resource, slug, params) {
        return ApiService.vueInstance.axios.put(`${ApiService.BaseUrl}/${resource}/${slug}`, params);
    }
    /**
     * @description Send the PUT HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static put(resource, params) {
        return ApiService.vueInstance.axios.put(`${ApiService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description Send the DELETE HTTP request
     * @param resource: string
     * @returns Promise<AxiosResponse>
     */
    static delete(resource) {
        return ApiService.vueInstance.axios.delete(resource);
    }
}
export default ApiService;
//# sourceMappingURL=ApiService.js.map